module.exports = {"pageTitleText":"OWASP 規則","ruleName":"規則名稱","owaspThresholdLimit":"Owasp 觸發閾值","owaspParanoiaLevel":"Owasp 嚴謹程度","owaspDetectRules":"Owasp 偵測規則"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/owasp.json
// module id = kuIu
// module chunks = 3